export interface BrandKitDebugFontDetails {
  role: string;
  name: string;
  specimenURL: string | null;
}

export interface BrandKitDebugDetails {
  name: string;
  colorHexes: string[];
  logoURL: string | null;
  fonts: BrandKitDebugFontDetails[];
}

const pendingRequestsByBrandKitId = new Map<string, Promise<BrandKitDebugDetails>>();

/**
 * Resolves a pinned brand kit for the super-user debug line, including kits the viewer does not own.
 * Every message pinned to the same kit shares one request, since the endpoint renders a typeface
 * specimen per font on a cache miss.
 */
export const getBrandKitDebugDetails = async (brandKitId: string): Promise<BrandKitDebugDetails> => {
  const alreadyRequested = pendingRequestsByBrandKitId.get(brandKitId);
  if (alreadyRequested) {
    return alreadyRequested;
  }

  const request = window.PMW.readLocal('ai/getSuperUserBrandKitDebugDetails', {brandKitId}) as Promise<BrandKitDebugDetails>;
  pendingRequestsByBrandKitId.set(brandKitId, request);

  request.catch(() => {
    pendingRequestsByBrandKitId.delete(brandKitId);
  });

  return request;
};
